import type { SenderRole } from './chat-model'

/**
 * 分享消息简化结构
 * 仅包含渲染分享卡片所需的字段
 */
export interface ShareMessage {
  id: string
  role: SenderRole
  content: string
}

/**
 * 分享数据载体
 * 用于构建分享卡片的完整数据
 */
export interface SharePayload {
  engineId: string
  engineTitle: string
  engineCoverUrl?: string
  shareUrl: string // /chats/new/{engineId}
  messages: ShareMessage[]
  createdAt: string
}

/**
 * 分享模式 Store 切片类型
 */
export interface ShareModeSlice {
  /** 是否处于分享模式 */
  isShareMode: boolean
  /** 已选中的消息 ID 集合 */
  selectedMessageIds: Set<string>
  /** 设置分享模式 */
  setShareMode: (isOpen: boolean) => void
  /** 切换消息选中状态 */
  toggleMessageSelection: (id: string) => void
  /** 清空选择 */
  clearSelection: () => void
}

/** 最大可选消息数量 */
export const MAX_SHARE_MESSAGES = 10
